import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { format, isValid, parse, parseISO } from 'date-fns';
import { Form } from '@unform/web';

import {
  FiCheckSquare,
  FiEdit2,
  FiSearch,
  FiTv,
  FiFileText,
} from 'react-icons/fi';

import api from 'services/api';
import { Avaliacaoeng, StatusArquivo } from 'utils/variables';
import { Container, Table, Scroll, Td } from './styles';
import Avatar from 'components/Avatar';
import { show } from 'store/modules/dialog/actions';

import { Chamada } from 'pages/@types';

import PlayerBaixa from 'components/PlayerBaixa';
import Card from 'components/Card';
import Input from 'components/Input';
import NotFound from 'components/NotFound';
import PendenteAvaliacao from 'assets/PendenteAvaliacao.svg';
import Pagination from 'components/Pagination';
import Loader from 'components/ContentLoader/GenericLoader';
import Flag from 'components/Flag';
import Button from 'components/Button';
import { FormHandles } from '@unform/core';
import { useModal } from 'hooks/modal';
import Tooltip from 'components/Tooltip';

export default function Arquivamento() {
  const [chamadas, setChamadas] = useState<Chamada[]>([]);
  const [loading, setLoading] = useState(false);
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [filtro, setFiltro] = useState('');
  const [selected, setSelected] = useState<Chamada>({} as Chamada);
  const dispatch = useDispatch();
  const { callback: callbackDialog } = useSelector(
    (state: any) => state.dialog,
  );
  const formRefRetranca = useRef<FormHandles>(null);
  const selectedId = useRef(0);
  const { showModal, hideModal } = useModal();

  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);
  const handlePlayer = useCallback(
    preview_url => {
      if (preview_url) {
        setPlayer({
          open: !player.open,
          midia_url: preview_url,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );

  const handleFichaTecnica = useCallback(
    (fichatecnica: string) => {
      console.log(fichatecnica);
      const options = {
        type: 'info',
        contentHTML: `<p>${fichatecnica.replaceAll('\n', '<br>')}</p>`,
        showConfirmButton: false,
        cancelButtonText: 'FECHAR',
      };
      dispatch(show(options));
    },
    [dispatch],
  );

  const handleSubmitRetranca = useCallback(async data => {
    const dateUnformatted = data.retrancaarquivo.substring(
      data.retrancaarquivo.length - 11,
      data.retrancaarquivo.length - 1,
    );
    const parsedDate = parse(dateUnformatted, 'dd-MM-yyyy', new Date());
    if (
      isValid(parsedDate) &&
      data.retrancaarquivo[data.retrancaarquivo.length - 1] === ')' &&
      data.retrancaarquivo[data.retrancaarquivo.length - 13] === ' ' &&
      data.retrancaarquivo[data.retrancaarquivo.length - 12] === '('
    ) {
      if (formRefRetranca.current) {
        try {
          await api.patch(
            `/arquivamento/${selectedId.current}/retrancaarquivo`,
            data,
          );

          setChamadas(prevState =>
            prevState.map(ch =>
              ch.id === selectedId.current
                ? {
                    ...ch,
                    retrancaarquivo: data.retrancaarquivo,
                  }
                : ch,
            ),
          );
          toast.success('Retranca do arquivo atualizada');
          hideModal();
        } catch (error) {
          if (error instanceof Error) toast.error(error.message);
        }
      }
    } else {
      toast.error('Retranca com Data Inválida');
    }
  }, []);

  const renderSubmitRetranca = useCallback(
    ch => {
      selectedId.current = ch.id;
      showModal({
        title: 'ALTERAÇÃO DE RETRANCA',
        component: (
          <Form
            initialData={ch}
            ref={formRefRetranca}
            onSubmit={handleSubmitRetranca}
          >
            <Input name="retrancaarquivo" />
            <div className="actions">
              <Button type="submit" color="primary">
                CONFIRMAR
              </Button>
            </div>
          </Form>
        ),
      });
    },
    [handleSubmitRetranca, hideModal],
  );

  const handleAutorizaArquivamento = useCallback(
    async chamada => {
      setSelected(chamada);
      const optionBase = {
        type: 'question',
        text: `Autorizar arquivamento de ${chamada.retranca}?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/arquivamento/${chamada.id}/statusarquivo`,
          method: api.patch,
          data: { statusarquivo: StatusArquivo.AUTORIZADO },
          action: 'arquivamento',
        },
        haveCallback: true,
        successMessage: 'Autorizado arquivamento da mídia!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(optionBase));
    },
    [dispatch],
  );

  // verifica se callback foi realizado com sucesso para então remover item da lista
  useEffect(() => {
    if (callbackDialog && callbackDialog.success) {
      if (callbackDialog.success.action === 'arquivamento') {
        setChamadas(prevState =>
          prevState.map(ch =>
            ch.id === selected.id ? { ...ch, statusarquivo: 'autorizado' } : ch,
          ),
        );
      }
    }
  }, [callbackDialog, selected.id]);

  useEffect(() => {
    const controller = new AbortController();
    async function loadArquivamento() {
      setLoading(true);
      try {
        const response = await api.get(`/arquivamento`, {
          signal: controller.signal,
          params: { page },
        });
        if (response && response.data) {
          setChamadas(response.data.chamadas);
          setPages(response.data.pages);
        }

        setLoading(false);
      } catch (e) {
        setLoading(false);
        if (e instanceof Error) toast.error(e.message);
        else toast.error('Erro inesperado');
      }
    }
    loadArquivamento();
    return () => {
      controller.abort();
    };
  }, [filtro, page]);

  return (
    <Container>
      <Card>
        <header>
          <h4>LISTA DE MATERIAIS PARA ARQUIVAMENTO</h4>
          <Pagination
            total={pages}
            activePage={page}
            onClick={page => setPage(page)}
          />
          <div>
            <Form
              onSubmit={e => {
                setPage(1);
                setFiltro(e.searchLocal);
              }}
            >
              <Input
                name="searchLocal"
                placeholder="Buscar na Tabela"
                icon={<FiSearch />}
                disabled
                // onChange={(e: MouseEvent) => handleBusca(e)}
              />
            </Form>
          </div>
        </header>
        <Scroll>
          {loading ? (
            <Loader />
          ) : chamadas && chamadas.length ? (
            <Table>
              <thead>
                <tr>
                  <th>RETRANCA</th>
                  <th>TIPO</th>
                  <th>ARQUIVAMENTO</th>
                  <th>DURAÇÃO</th>
                  <th>EDITOR</th>
                  <th>DATA</th>
                  <th>AÇÕES</th>
                </tr>
              </thead>

              <tbody>
                {chamadas.length &&
                  chamadas.map(
                    (chamada: Chamada) =>
                      chamada.midia && (
                        <tr key={chamada.id}>
                          <Td>
                            {chamada.retrancaarquivo ? (
                              <>
                                {chamada.retrancaarquivo}
                                <strong>({chamada.retranca})</strong>
                              </>
                            ) : (
                              chamada.retranca
                            )}
                            <Button
                              fill
                              color="font"
                              round
                              onClick={() => renderSubmitRetranca(chamada)}
                              disabled={
                                chamada.statusarquivo !==
                                StatusArquivo.SOLICITADO
                              }
                            >
                              <FiEdit2 />
                            </Button>
                          </Td>
                          <td>
                            <Flag name={chamada.tipo} type={chamada.tipo} />
                          </td>
                          <td>
                            <Flag
                              name={
                                chamada.statusarquivo ===
                                StatusArquivo.AUTORIZADO
                                  ? chamada.midia.avaliacaoeng ===
                                    Avaliacaoeng.PENDENTE
                                    ? 'pendente eng'
                                    : chamada.midia.avaliacaoeng ===
                                      Avaliacaoeng.REPROVADO
                                    ? 'reprovado eng'
                                    : chamada.statusarquivo
                                  : chamada.statusarquivo
                              }
                              type={
                                chamada.statusarquivo ===
                                StatusArquivo.AUTORIZADO
                                  ? chamada.midia.avaliacaoeng ===
                                      Avaliacaoeng.PENDENTE ||
                                    chamada.midia.avaliacaoeng ===
                                      Avaliacaoeng.REPROVADO
                                    ? chamada.midia.avaliacaoeng
                                    : chamada.statusarquivo
                                  : chamada.statusarquivo
                              }
                            />
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {chamada.duracao}s
                          </td>
                          <td>
                            <Avatar
                              size="40"
                              name={chamada.editor.nome}
                              src={chamada.editor.avatar_url}
                              round
                            />
                          </td>
                          <td>
                            {chamada.datainicio
                              ? format(
                                  parseISO(chamada.datainicio),
                                  'dd-MM-yyyy',
                                )
                              : 'Não informada'}
                          </td>
                          <td>
                            <div>
                              <Button
                                id={`id_ficha_${chamada.id}`}
                                fill
                                color="font"
                                round
                                size="xsm"
                                disabled={!chamada.fichatecnica}
                                onClick={() =>
                                  handleFichaTecnica(chamada.fichatecnica || '')
                                }
                              >
                                <FiFileText />
                              </Button>
                              <Tooltip target={`id_ficha_${chamada.id}`}>
                                FICHA TÉCNICA
                              </Tooltip>
                              <Button
                                id={`id_arquivar_${chamada.id}`}
                                fill
                                color="font"
                                round
                                onClick={() =>
                                  handleAutorizaArquivamento(chamada)
                                }
                                disabled={
                                  !chamada.retrancaarquivo ||
                                  chamada.statusarquivo !==
                                    StatusArquivo.SOLICITADO
                                }
                              >
                                <FiCheckSquare />
                              </Button>
                              <Tooltip target={`id_arquivar_${chamada.id}`}>
                                AUTORIZAR
                              </Tooltip>
                              <Button
                                id={`id_player_${chamada.id}`}
                                fill
                                color="font"
                                round
                                size="xsm"
                                onClick={() =>
                                  handlePlayer(chamada.midia.preview_url)
                                }
                              >
                                <FiTv />
                              </Button>
                              <Tooltip target={`id_player_${chamada.id}`}>
                                ASSISTIR
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      ),
                  )}
              </tbody>
            </Table>
          ) : (
            <NotFound
              img={PendenteAvaliacao}
              title="Materiais para arquivamento"
            >
              Nenhum MATERIAL encontrado
            </NotFound>
          )}
        </Scroll>
      </Card>
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
}
